import { SignInUrlBuilder } from '@tableau/shared-urls/lib/src/SignInUrlBuilder';
import { ButtonType, ButtonWidget } from '@tableau/widgets';
import { useEffect } from 'react';
import React = require('react');
import { callListIdentityPools, ListIdentityPoolsResult } from '~src/authentication/serverApi/requests/identityPools/ListIdentityPoolsRequest';
import { IIdentityPool } from '~src/authentication/serverApi/types/identityPools/IIdentityPool';
import { IdentityPoolService } from '~src/authentication/services/IdentityPoolService';
import { WindowLocationService } from '~src/commonInfra/services/WindowLocationService';


export interface IdentityPoolsLoginPageProps {
}

export function IdentityPoolsLoginPage(props: IdentityPoolsLoginPageProps) {
  const [identityPools, setIdentityPools] = React.useState([] as IIdentityPool[]);

  useEffect(() => {
    callListIdentityPools().then((result: ListIdentityPoolsResult) => {
      if (result.identityPools && result.identityPools.length > 0) {
        setIdentityPools(result.identityPools);
      } else {
        // No identity pools found, only option is legacy login.
        navigateToLegacyServerWideLoginPage();
      }
    });
  }, []);

  return <>
    <div>
      <ButtonWidget buttonType={ButtonType.Primary}
        testId='default-identity-pool'
        onClick={navigateToLegacyServerWideLoginPage}>
        {'Default Identity Pool '}
      </ButtonWidget>
    </div>

    <hr />

    {identityPools.filter(x => x.enabled).map((identityPool, index) => {
      return <div key={index}>
        <ButtonWidget
          buttonType={ButtonType.Primary}
          testId={'identity-pool-' + identityPool.id}
          onClick={() => IdentityPoolService.kickoffLogin(identityPool)}>
          {identityPool.name}
        </ButtonWidget>
      </div>;
    })}
  </>;
}

function navigateToLegacyServerWideLoginPage() {
  WindowLocationService.setHashQueryParameter(SignInUrlBuilder.QueryKey.isDefaultIdentityPoolLogin, 'true');
}
